import MutationAccordion from './MutationAccordion';

export default MutationAccordion;
